import { Trans } from '~/common/context';
import { Button, Flex, Text, Title } from '@wyz/ui';
import { Link } from 'react-router';
import React from 'react';
import { serialize } from '@wyz/utils';

type Props = {
  reference: string;
};

function QuoteCreated({ reference }: Props) {
  return (
    <Flex direction='column' alignItems='center'>
      <Background className='my-5' />
      <Title heading='xl' weight='bold' color='tertiary' className='mb-2'>
        <Trans i18nKey='app.purchase.quote_cart_page.quote_created.title' />
      </Title>
      <Button
        id='quote-details'
        variant='primary'
        as={Link}
        to={`/quotes/history?${serialize({ searchQuery: reference })}`}
      >
        <Text heading='normal' weight='semi-bold' color='white'>
          <Trans i18nKey='app.purchase.quote_cart_page.empty_cart.quote_created.button' />
        </Text>
      </Button>
    </Flex>
  );
}

export default QuoteCreated;

function Background(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='512'
      height='352'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 512 352'
      {...props}
    >
      <path
        style={{ fill: '#C1CBD7' }}
        d='M335.7,329.8l-179.3-12.5c-7.8-0.5-13.7-7.3-13.1-15.2l17.7-253.5c0.5-7.8,7.3-13.8,15.1-13.2l179.3,12.5
	c7.8,0.5,13.7,7.3,13.1,15.2l-17.7,253.5C350.3,324.4,343.5,330.3,335.7,329.8z'
      />
      <path
        style={{ fill: '#ECF0F3' }}
        d='M307.8,308.7l-145.2-10.2l17.1-243.8l169.7,12l-15.3,219L307.8,308.7z'
      />
      <path
        style={{ fill: '#ECF0F3' }}
        d='M307.8,308.7l-145.2-10.6l17.1-243.8l169.7,12L334,285.7L307.8,308.7z'
      />
      <path
        style={{ fill: '#D3DCE3' }}
        d='M309.5,283.9l24.5,1.7l-26.3,23L309.5,283.9z'
      />
      <path
        style={{ fill: '#93A5B9' }}
        d='M305,51l-79.2-5.5l0.7-10.4c0.4-5.3,4.9-9.3,10.2-8.9l60.1,4.2c5.3,0.4,9.3,5,8.9,10.3L305,51z'
      />
      <path
        style={{ fill: '#ABBAC9' }}
        d='M319.6,72.2l-111.3-7.8l1-14.9c0.5-7.6,7-13.3,14.4-12.8l84.4,5.9c7.4,0.5,13,7.1,12.5,14.6L319.6,72.2z'
      />
      <path
        style={{ fill: '#93A5B9' }}
        d='M250.1,184.3c0.5-0.7,1-1.5,1.6-2.2c16.7-16.7,33.3-33.3,50-49.9c2.5-2.5,3.6-2.5,6.1,0
	c4.5,4.4,9,8.9,13.4,13.3c2.3,2.3,2.3,3.5,0.1,5.7c-23,22.9-45.9,45.8-68.9,68.8c-2.3,2.3-3.4,2.2-5.7-0.1
	c-12-12-24.1-24.1-36.1-36.1c-2.7-2.7-2.7-3.6,0.1-6.3c4.5-4.5,8.9-8.9,13.4-13.4c2.2-2.2,3.3-2.1,5.5,0
	C236.2,170.7,242.9,177.2,250.1,184.3z M305.1,137.1c-1.2,1.1-2,1.8-2.7,2.6c-16.4,16.4-32.8,32.7-49.2,49.1c-3,3-4.3,2.9-7.1,0
	c-5.8-6-11.8-11.8-17.6-17.8c-1.2-1.2-2-1.1-3.2,0.1c-2.6,2.7-5.1,5.4-7.9,7.9c-1.7,1.5-1.5,2.3,0,3.7c9.4,9.3,18.7,18.6,28.1,28
	c1.4,1.4,2.7,3,3.8,4.2c22.4-22.3,44.6-44.5,66.2-66C312.1,145.1,308.7,141.2,305.1,137.1z'
      />
    </svg>
  );
}
